<template>
  <div class="main-panel">
    <div class="nav-bar-operations">
      <img src="@/assets/logogruas.png" alt="HomePage" class="logo-button" />
    </div>

    <header class="header">
      <div class="header__left">
        <div class="avatar" aria-hidden="true">🛠️</div>
        <div class="greet">
          <h1>Logs de Mantenimiento</h1>
          <p class="sub">Órdenes, incidentes y unidades</p>
        </div>
      </div>
      <div class="header__right">
        <button class="btn btn--ghost" @click="goBack">Volver</button>
      </div>
    </header>

    <section class="filters">
      <div class="field">
        <label>Tipo de objeto</label>
        <select v-model="objectType">
          <option value="maintenance_order">Orden de mantenimiento</option>
          <option value="incident">Incidente</option>
          <option value="unit">Unidad</option>
        </select>
      </div>
      <div class="field">
        <label>Identificador</label>
        <input v-model="objectId" type="text" placeholder="Ej: 1024" />
      </div>
      <div class="field">
        <label>Usuario</label>
        <input v-model="username" type="text" placeholder="Ej: jrodriguez" />
      </div>
      <div class="field">
        <label>Fecha inicio</label>
        <input v-model="dateFrom" type="date" />
      </div>
      <div class="field">
        <label>Fecha fin</label>
        <input v-model="dateTo" type="date" />
      </div>
      <div class="actions">
        <button class="btn btn--primary" @click="search" :disabled="loading">Buscar</button>
        <button class="btn btn--ghost" @click="downloadCsv" :disabled="loading">Descargar CSV</button>
        <button class="btn btn--ghost" @click="clear">Limpiar</button>
      </div>
    </section>

    <section class="results">
      <div v-if="error" class="error">{{ error }}</div>
      <div v-if="!loading" class="summary">
        <span>{{ totalCount }} resultados</span>
      </div>
      <div v-if="loading" class="loading">Cargando...</div>
      <div v-else-if="logs.length" class="log-list">
        <article v-for="log in logs" :key="log.id" class="log-card">
          <div class="log-head">
            <div>
              <strong>{{ log.method }}</strong>
              <span class="status">({{ log.status_code || '—' }})</span>
            </div>
            <div class="time">{{ formatDate(log.created_at) }}</div>
          </div>
          <div class="endpoint">{{ log.endpoint }}</div>
          <div class="meta">
            <span>Usuario: {{ log.username || log.user_id || '—' }}</span>
            <span>Componente: {{ log.component || '—' }}</span>
            <span>Ruta: {{ log.route_path || '—' }}</span>
          </div>
          <details>
            <summary>Detalles</summary>
            <pre>{{ formatJson(log.payload) }}</pre>
            <pre>{{ formatJson(log.params) }}</pre>
            <pre>{{ formatJson(log.response_body) }}</pre>
          </details>
        </article>
      </div>
      <div v-else class="empty">Sin resultados</div>
      <div v-if="totalPages > 1" class="pagination">
        <button class="btn btn--ghost" @click="prevPage" :disabled="page === 1 || loading">Anterior</button>
        <span>Página {{ page }} de {{ totalPages }}</span>
        <button class="btn btn--ghost" @click="nextPage" :disabled="page === totalPages || loading">Siguiente</button>
      </div>
    </section>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'SearchMaintenanceLogs',
  data() {
    return {
      objectType: 'maintenance_order',
      objectId: '',
      username: '',
      dateFrom: '',
      dateTo: '',
      logs: [],
      totalCount: 0,
      page: 1,
      pageSize: 50,
      loading: false,
      error: null,
    }
  },
  computed: {
    totalPages() {
      return Math.max(1, Math.ceil(this.totalCount / this.pageSize))
    },
  },
  methods: {
    buildParams() {
      const params = {
        module: 'mantenimiento',
        object_type: this.objectType,
        object_id: this.objectId || undefined,
        username: this.username || undefined,
        date_from: this.dateFrom || undefined,
        date_to: this.dateTo || undefined,
        limit: this.pageSize,
        offset: (this.page - 1) * this.pageSize,
      }
      Object.keys(params).forEach((key) => {
        if (params[key] === undefined || params[key] === '') {
          delete params[key]
        }
      })
      return params
    },
    async search() {
      const apiDirectory = process.env.API_DIRECTORY
      this.loading = true
      this.error = null
      try {
        const { data } = await axios.get(`${apiDirectory}/logs/search`, {
          params: this.buildParams(),
          headers: { Authorization: 'Token ' + localStorage.getItem('authToken') },
        })
        this.logs = data.results || []
        this.totalCount = data.count || 0
        if (this.page > this.totalPages) {
          this.page = this.totalPages
        }
      } catch (err) {
        this.error = 'No se pudo cargar los logs.'
      } finally {
        this.loading = false
      }
    },
    async downloadCsv() {
      const apiDirectory = process.env.API_DIRECTORY
      try {
        const { data } = await axios.get(`${apiDirectory}/logs/search`, {
          params: { ...this.buildParams(), format: 'csv', export_all: 1 },
          responseType: 'blob',
          headers: { Authorization: 'Token ' + localStorage.getItem('authToken') },
        })
        const blob = new Blob([data], { type: 'text/csv' })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = 'logs_mantenimiento.csv'
        link.click()
        URL.revokeObjectURL(url)
      } catch (err) {
        this.error = 'No se pudo descargar el CSV.'
      }
    },
    clear() {
      this.objectType = 'maintenance_order'
      this.objectId = ''
      this.username = ''
      this.dateFrom = ''
      this.dateTo = ''
      this.logs = []
      this.totalCount = 0
      this.page = 1
      this.error = null
    },
    formatJson(value) {
      if (!value) return ''
      return JSON.stringify(value, null, 2)
    },
    formatDate(value) {
      if (!value) return '—'
      return new Date(value).toLocaleString()
    },
    goBack() {
      this.$router.back()
    },
    nextPage() {
      if (this.page < this.totalPages) {
        this.page += 1
        this.search()
      }
    },
    prevPage() {
      if (this.page > 1) {
        this.page -= 1
        this.search()
      }
    },
  },
}
</script>

<style scoped>
.main-panel { min-height: 100vh; background: #f7f8fb; padding: 12vh 24px 48px; }
.nav-bar-operations {
  position: absolute; top: 0; left: 0; width: 100vw; height: 10vh;
  background-color: #ffc434; z-index: 1000; display: flex; align-items: center; padding-left: 16px;
}
.logo-button { height: 55%; object-fit: contain; }
.header { margin-top: 12px; display: flex; align-items: center; justify-content: space-between; gap: 16px; }
.header__left { display: flex; align-items: center; gap: 14px; }
.avatar {
  width: 44px; height: 44px; border-radius: 10px; display: grid; place-items: center;
  background: linear-gradient(135deg, #ffc434, #ffe188); color: #3a2a00; font-weight: 800;
}
.greet h1 { font-size: 1.15rem; color: #0f172a; margin: 0; }
.greet .sub { margin: 2px 0 0; color: #667085; font-size: .9rem; }
.filters {
  margin-top: 16px; background: #fff; padding: 16px; border-radius: 14px;
  display: grid; gap: 12px; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  border: 1px solid rgba(0,0,0,.08);
  align-items: end;
}
.field { display: grid; gap: 6px; }
.field label { font-size: .85rem; color: #475467; }
.field input, .field select {
  padding: 8px 10px; border-radius: 10px; border: 1px solid rgba(0,0,0,.15); outline: none;
  width: 100%; box-sizing: border-box;
}
.actions { display: flex; gap: 10px; align-items: end; flex-wrap: wrap; }
.btn {
  display: inline-flex; align-items: center; gap: 8px;
  padding: 10px 14px; border-radius: 12px; border: 1px solid transparent;
  background: #151924; color: #fff; cursor: pointer; text-decoration: none;
}
.btn--primary { background: #2563eb; color: #fff; }
.btn--ghost { background: transparent; border: 1px solid rgba(0,0,0,.15); color: #0f172a; }
.results { margin-top: 16px; }
.summary { color: #667085; margin-bottom: 8px; }
.log-list { display: grid; gap: 12px; }
.log-card { background: #fff; border-radius: 12px; padding: 12px; border: 1px solid rgba(0,0,0,.08); }
.log-head { display: flex; justify-content: space-between; align-items: center; }
.endpoint { margin: 6px 0; color: #111827; font-weight: 600; }
.meta { display: flex; gap: 12px; flex-wrap: wrap; color: #667085; font-size: .85rem; }
.status { margin-left: 6px; color: #2563eb; }
.error { color: #b42318; margin-bottom: 8px; }
.empty { color: #667085; padding: 16px 0; }
.pagination { margin-top: 12px; display: flex; gap: 10px; align-items: center; justify-content: flex-end; color: #667085; }
details { margin-top: 8px; }
pre { background: #f8fafc; padding: 8px; border-radius: 8px; overflow: auto; }
</style>
